import { TableCell, TableCellProps, Tooltip } from '@mui/material';
import { dateToFrontEndFormat } from 'common/utils/dateHelpers';

export function TableCellWithTooltip({ value, tableCellProps, isDateTime = false }: Readonly<{value: string, tableCellProps?: TableCellProps, isDateTime?: boolean}>) {
    if (isDateTime) {
        value = dateToFrontEndFormat(value, true);
    }

    return (
        <TableCell {...tableCellProps}>
            <Tooltip
                title={value}
                slotProps={{
                    popper: {
                        modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, -5],
                                },
                            },
                        ],
                    },
                }}
            >
                <span
                    style={{
                        display: 'inline-block',
                        maxWidth: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {value}
                </span>
            </Tooltip>
        </TableCell>
    );
}
